import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faClipboardCheck, faQuestionCircle, faShippingFast, faTruck, faTruckLoading } from '@fortawesome/pro-duotone-svg-icons'
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome'
import React, { FC, Fragment, ReactNode } from 'react'
import { TripStatus } from 'services/enums'

type Props = {
    status: TripStatus
}

export const LoadStatusIcon: FC<Props> = ({ status }) => {
    let loadStatusIconStyle = {
        padding: '.1em',
    }

    let loadIcon = (status: TripStatus): ReactNode => {
        let iconSettings: FontAwesomeIconProps = {} as FontAwesomeIconProps

        switch (status) {
            case TripStatus.Ready: iconSettings = { icon: faTruck as IconProp, color: '#40a339' }; break;
            case TripStatus.Waiting:
            case TripStatus.Importing: iconSettings = {icon: faTruckLoading as IconProp, color: '#d12435'}; break;
            case TripStatus.Started: iconSettings = { icon: faShippingFast as IconProp, color: '#F2994A' }; break;
            case TripStatus.Complete: iconSettings = { icon: faClipboardCheck as IconProp, color: '#40a339' }; break;
            default: iconSettings = { icon: faQuestionCircle as IconProp, color: '#0066A4' }; break;
        }

        return <FontAwesomeIcon icon={iconSettings.icon as IconProp} size={'5x'} color={iconSettings.color} style={loadStatusIconStyle} />
    }

    return (
        <Fragment>
            {loadIcon(status)}
        </Fragment>
    )
}